<template>
  <label
    class="important-calendar"
    :class="invalidClass"
    :data-error="invalid"
  >
    <input
      v-bind="$attrs"
      :class="className"
      type="date"
      name="date"
      :value="value"
      required
      @input="emitCalendar"
    >
  </label>
</template>

<script>
export default {
  name: 'ImportantCalendar',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    },
    invalid: {
      type: String,
      default: null
    }
  },
  computed: {
    className() {
      return this.value ? 'important-calendar__input' : 'important-calendar__input important-calendar__input_type_button'
    },
    invalidClass() {
      return this.invalid ? 'invalid' : ''
    }
  },
  methods: {
    emitCalendar({target}) {
      this.$emit('input', target.value )
    }
  }
}
</script>

<style lang="scss">
.important-calendar {
  --invalid-color: #DB4835;

  position: relative;

  &.invalid {
    &::after {
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      color: var(--invalid-color);
      font-size: 12px;
      content: attr(data-error);
    }
  }

  &__input {
    position: relative;
    color: #333333;
    font-size: 14px;
    font-family: inherit;
    border: none;
    outline: none;
    transition: opacity .3s;

    &:hover {
      opacity: 0.7
    }

    &::-webkit-calendar-picker-indicator {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: auto;
      height: auto;
      color: transparent;
      background: transparent;
    }

    &_type {
      &_button {
        &:before {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: #fff;
          content: attr(placeholder);
        }
      }
    }
  }
}
</style>
